import { assignSafe } from './functions/assign-safe';
export interface ICoreObject {
  id?: string;
  name?: string;
  toShortString(): string | undefined;
}

export class CoreObject implements ICoreObject {
  constructor(jsonData?: Partial<CoreObject>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }

  id?: string;
  name?: string;

  toShortString(): string | undefined {
    return this.name;
  }
}
